if (!customElements.get('collection-load-more')) {
  customElements.define('collection-load-more', class extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('[data-collection-load-more-link]');
      this.status = this.querySelector('[data-collection-load-more-status]');
      this.grid = document.getElementById(this.dataset.gridId);
      if (!this.link || !this.grid) return;

      this.label = this.link.textContent;
      this.link.addEventListener('click', this.loadMore);
      if ('IntersectionObserver' in window && !navigator.connection?.saveData) {
        this.observer = new IntersectionObserver(this.loadWhenVisible, { rootMargin: '0px 0px 320px 0px' });
        this.observer.observe(this);
      }
    }

    disconnectedCallback() {
      this.link?.removeEventListener('click', this.loadMore);
      this.observer?.disconnect();
      this.controller?.abort();
    }

    loadWhenVisible = entries => {
      if (entries.some(entry => entry.isIntersecting)) this.load();
    };

    loadMore = event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      this.load();
    };

    async load() {
      if (this.loading) return;
      this.loading = true;
      this.observer?.unobserve(this);
      this.controller = new AbortController();
      this.setLoading(true);

      try {
        const url = new URL(this.link.href);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error(`Collection page request failed: ${response.status}`);

        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = page.getElementById(this.dataset.gridId);
        const cards = [...(nextGrid?.children || [])];
        if (!cards.length) throw new Error('Collection page did not contain products');

        cards.forEach(card => this.grid.append(document.importNode(card, true)));
        if (typeof SHTElementLazyLoad !== 'undefined') new SHTElementLazyLoad();

        const nextLink = page.querySelector('[data-collection-load-more-link]');
        if (!nextLink) {
          this.status.textContent = 'All products loaded';
          this.remove();
          return;
        }

        const nextUrl = new URL(nextLink.href);
        nextUrl.searchParams.delete('section_id');
        this.link.href = nextUrl;
        this.status.textContent = `${cards.length} more products loaded`;
        this.link.textContent = this.label;
        this.observer?.observe(this);
      } catch (error) {
        if (error.name === 'AbortError') return;
        console.error(error);
        this.link.textContent = 'Try again';
        this.status.textContent = 'Products could not be loaded. Select Try again to retry.';
      } finally {
        this.loading = false;
        this.setLoading(false);
      }
    }

    setLoading(loading) {
      this.toggleAttribute('aria-busy', loading);
      this.link.toggleAttribute('aria-disabled', loading);
      if (loading) this.link.textContent = 'Loading…';
    }
  });
}
